import produce from 'immer';
import { DateTime } from 'luxon';

import * as Types from './types';
import { LAST_24_HOURS_VALUE } from '../constants';
import { actionTypes } from './constants';

export const initialEndDate = new Date();

export const initialStartDate = DateTime.local()
    .minus({ days: LAST_24_HOURS_VALUE })
    .toJSDate();

export const defaultState: Types.ILoginHistoryState = {
    period: LAST_24_HOURS_VALUE,
    startDate: initialStartDate,
    endDate: initialEndDate,
    page: {
        pageId: 1,
        nextPageId: 0,
        isPageChanged: false
    },
    totalCount: 0,
    isLoading: false,
    error: '',
    history: []
};

export const reducer = (reducerSuffix: string) =>
    produce((draftState, action: Types.TLoginHistoryAction): Types.ILoginHistoryState | void => {
    switch (action.type) {
        case actionTypes.SET_DATA:
        case actionTypes.SET_DATA + reducerSuffix as actionTypes.SET_DATA: {
            const { page, ...rest } = action.payload;

            Object.assign(draftState, {
                page: {
                    ...draftState.page,
                    ...page
                },
                ...rest
            });

            break;
        }

        case actionTypes.UPDATE_HISTORY:
        case actionTypes.UPDATE_HISTORY + reducerSuffix as actionTypes.UPDATE_HISTORY: {
            const { history: newHistory, nextPageId, totalCount = 0 } = action.payload;

            const history = draftState.page.isPageChanged
                ? [...draftState.history, ...newHistory]
                : newHistory;

            Object.assign(draftState, {
                page: {
                    ...draftState.page,
                    isPageChanged: false,
                    nextPageId
                },
                history,
                totalCount
            });

            break;
        }

        case actionTypes.LOAD_NEXT_PAGE:
        case actionTypes.LOAD_NEXT_PAGE + reducerSuffix: {
            Object.assign(draftState, {
                page: {
                    ...draftState.page,
                    pageId: draftState.page.nextPageId,
                    isPageChanged: true
                }
            });

            break;
        }

        default:
            break;
    }
}, defaultState);
